// Event dates arrive as UTC strings with no zone marker.
export const utc = (value) => (value ? value.replace("T", " ").slice(0, 16) : "-");

const MONTHS = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];

const dayMonth = (value) =>
	`${Number(value.slice(8, 10))} ${MONTHS[Number(value.slice(5, 7)) - 1]}`;

export const shortUtc = (value) =>
	value ? `${dayMonth(value)} ${value.slice(11, 16)}` : "-";

export const shortDate = (value) => (value ? dayMonth(value) : "-");
